import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";

import ErrorDialog from "../common/ErrorDialog";
import TopBar from "../common/TopBar";
import CalendarHeader from "../common/CalendarHeader";
import CalendarBody from "../common/CalendarBody";
import { fetchServiceCount } from "../../helper/Api";
import { errors, getApiError } from "../../helper/Error";

export default function Calendar() {
  const todayDate = useMemo(() => new Date(), []);
  const location = useLocation();
  const errorRef = useRef({});

  const getDefaultTargetDate = useCallback(() => {
    let defaultTargetDate = location.state && location.state.defaultTargetDate;
    if (defaultTargetDate === undefined) {
      defaultTargetDate = todayDate;
    }

    return defaultTargetDate;
  }, [todayDate, location.state]);

  const [targetDate, setTargetDate] = useState(getDefaultTargetDate);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isOpenError, setIsOpenError] = useState(false);
  const handleCloseError = useCallback(() => {
    setIsOpenError(false);
  }, []);

  useEffect(() => {
    const fn = async () => {
      setIsLoading(true);

      await fetchServiceCount(targetDate)
        .then((res) => {
          if (res.data.error.length === 0) setData(res.data.result);
          else throw res.data.error;
        })
        .catch((err) => {
          errorRef.current = err.code
            ? getApiError(err)
            : errors.APP_CONNECTION_FAILED;
          setIsOpenError(true);
        });

      setIsLoading(false);
    };
    fn();
  }, [targetDate]);

  return (
    <>
      <TopBar isLoading={isLoading} />

      <CalendarHeader setTargetDate={setTargetDate} targetDate={targetDate} />

      <CalendarBody data={data} targetDate={targetDate} />

      <ErrorDialog
        open={isOpenError}
        onClose={handleCloseError}
        error={errorRef.current}
      />
    </>
  );
}
